module.exports = __webpack_public_path__ + "img/sales.1172632b.svg";